import { render, staticRenderFns } from "./InviteForm.vue?vue&type=template&id=2784e4fc&scoped=true"
import script from "./InviteForm.vue?vue&type=script&lang=js"
export * from "./InviteForm.vue?vue&type=script&lang=js"
import style0 from "./InviteForm.vue?vue&type=style&index=0&id=2784e4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784e4fc",
  null
  
)

export default component.exports